// Section Registry
// Defines all selectable page sections for the tasks capture tool.
// Each section gets a data-select-target attribute on its DOM container
// and is the only target the capture overlay can lock onto.

// ── Shared sections (present on every page) ──
export const sharedSections = [{
  selectTarget: "Navigation Bar",
  pageType: "organization",
  pagePatterns: ["*"]
}, {
  selectTarget: "Footer",
  pageType: "organization",
  pagePatterns: ["*"]
}];

// ── Homepage ──
export const homeIndexSections = [{
  selectTarget: "News Carousel",
  pageType: "article",
  pagePatterns: ["/"]
}, {
  selectTarget: "Services Banner",
  pageType: "organization",
  pagePatterns: ["/"]
}, {
  selectTarget: "Industry Updates",
  pageType: "article",
  pagePatterns: ["/"]
}, {
  selectTarget: "Featured Organizations",
  pageType: "organization",
  pagePatterns: ["/"]
}, {
  selectTarget: "Featured Events",
  pageType: "event",
  pagePatterns: ["/"]
}, {
  selectTarget: "Upcoming Events",
  pageType: "event",
  pagePatterns: ["/"]
}, {
  selectTarget: "Newsletter Signup",
  pageType: "organization",
  pagePatterns: ["/"]
}];

// ── Organization Index ──
export const orgIndexSections = [{
  selectTarget: "Organizations Directory Header",
  pageType: "organization",
  pagePatterns: ["/organizations"]
}, {
  selectTarget: "Featured Organization",
  pageType: "organization",
  pagePatterns: ["/organizations"]
}, {
  selectTarget: "Organization Filters",
  pageType: "organization",
  pagePatterns: ["/organizations"]
}, {
  selectTarget: "Organization Card Grid",
  pageType: "organization",
  pagePatterns: ["/organizations"]
}, {
  selectTarget: "Remaining Organizations",
  pageType: "organization",
  pagePatterns: ["/organizations"]
}];

// ── Organization Detail ──
export const orgDetailSections = [{
  selectTarget: "Organization Header",
  pageType: "organization",
  pagePatterns: ["/organizations/[id]"]
}, {
  selectTarget: "Organization About",
  pageType: "organization",
  pagePatterns: ["/organizations/[id]"]
}, {
  selectTarget: "Attributed Events",
  pageType: "organization",
  pagePatterns: ["/organizations/[id]"]
}, {
  selectTarget: "Organization Services",
  pageType: "organization",
  pagePatterns: ["/organizations/[id]"]
}, {
  selectTarget: "Attributed Regulations",
  pageType: "organization",
  pagePatterns: ["/organizations/[id]"]
}, {
  selectTarget: "Attributed Articles",
  pageType: "organization",
  pagePatterns: ["/organizations/[id]"]
}, {
  selectTarget: "Attributed Professionals",
  pageType: "professional",
  pagePatterns: ["/organizations/[id]"]
}, {
  selectTarget: "Footer Consulting Banner",
  pageType: "organization",
  pagePatterns: ["/organizations/[id]"]
}];

// ── Organization Create ──
export const orgCreateSections = [{
  selectTarget: "Organization Banner Upload",
  pageType: "organization",
  pagePatterns: ["/organizations/create"]
}, {
  selectTarget: "About",
  pageType: "organization",
  pagePatterns: ["/organizations/create"]
}, {
  selectTarget: "Contact",
  pageType: "organization",
  pagePatterns: ["/organizations/create"]
}, {
  selectTarget: "Expertise",
  pageType: "organization",
  pagePatterns: ["/organizations/create"]
}, {
  selectTarget: "Claim Form",
  pageType: "organization",
  pagePatterns: ["/organizations/create"]
}];

// ── Events Index ──
export const eventsIndexSections = [{
  selectTarget: "Events Hero",
  pageType: "event",
  pagePatterns: ["/events"]
}, {
  selectTarget: "Events Category Filters",
  pageType: "event",
  pagePatterns: ["/events"]
}, {
  selectTarget: "Events Card Grid",
  pageType: "event",
  pagePatterns: ["/events"]
}];

// ── Events Detail ──
export const eventsDetailSections = [{
  selectTarget: "Event Header",
  pageType: "event",
  pagePatterns: ["/events/[id]"]
}, {
  selectTarget: "Event About",
  pageType: "event",
  pagePatterns: ["/events/[id]"]
}, {
  selectTarget: "Event Agenda",
  pageType: "event",
  pagePatterns: ["/events/[id]"]
}, {
  selectTarget: "Event Speakers",
  pageType: "event",
  pagePatterns: ["/events/[id]"]
}, {
  selectTarget: "Organization Attribution",
  pageType: "event",
  pagePatterns: ["/events/[id]"]
}, {
  selectTarget: "Event Sidebar",
  pageType: "event",
  pagePatterns: ["/events/[id]"]
}, {
  selectTarget: "Organization Events",
  pageType: "event",
  pagePatterns: ["/events/[id]"]
}, {
  selectTarget: "Event Related",
  pageType: "event",
  pagePatterns: ["/events/[id]"]
}];

// ── Events Create ──
export const eventsCreateSections = [{
  selectTarget: "Event Banner Upload",
  pageType: "event",
  pagePatterns: ["/events/create"]
}, {
  selectTarget: "Event Details",
  pageType: "event",
  pagePatterns: ["/events/create"]
}, {
  selectTarget: "Event Format",
  pageType: "event",
  pagePatterns: ["/events/create"]
}, {
  selectTarget: "Speakers",
  pageType: "event",
  pagePatterns: ["/events/create"]
}, {
  selectTarget: "Agenda",
  pageType: "event",
  pagePatterns: ["/events/create"]
}, {
  selectTarget: "Organization Attribution",
  pageType: "event",
  pagePatterns: ["/events/create"]
}, {
  selectTarget: "Event Settings",
  pageType: "event",
  pagePatterns: ["/events/create"]
}];

// ── Regulations Index ──
export const regulationsIndexSections = [{
  selectTarget: "Side Navigation",
  pageType: "regulation",
  pagePatterns: ["/regulations"]
}, {
  selectTarget: "Regulations Card Grid",
  pageType: "regulation",
  pagePatterns: ["/regulations"]
}];

// ── Regulations Detail ──
export const regulationsDetailSections = [{
  selectTarget: "Side Navigation",
  pageType: "regulation",
  pagePatterns: ["/regulations/[id]"]
}, {
  selectTarget: "Regulation Header",
  pageType: "regulation",
  pagePatterns: ["/regulations/[id]"]
}, {
  selectTarget: "Regulation Summary",
  pageType: "regulation",
  pagePatterns: ["/regulations/[id]"]
}, {
  selectTarget: "Regulation Content",
  pageType: "regulation",
  pagePatterns: ["/regulations/[id]"]
}, {
  selectTarget: "Related Regulations",
  pageType: "regulation",
  pagePatterns: ["/regulations/[id]"]
}];

// ── Regulations Create ──
export const regulationsCreateSections = [{
  selectTarget: "Toolbar",
  pageType: "regulation",
  pagePatterns: ["/regulations/create"]
}, {
  selectTarget: "Header Card",
  pageType: "regulation",
  pagePatterns: ["/regulations/create"]
}, {
  selectTarget: "Main Content",
  pageType: "regulation",
  pagePatterns: ["/regulations/create"]
}];

// ── Articles Index ──
export const articlesIndexSections = [{
  selectTarget: "Side Navigation",
  pageType: "article",
  pagePatterns: ["/articles"]
}, {
  selectTarget: "Articles List",
  pageType: "article",
  pagePatterns: ["/articles"]
}];

// ── Articles Detail ──
export const articlesDetailSections = [{
  selectTarget: "Side Navigation",
  pageType: "article",
  pagePatterns: ["/articles/[id]"]
}, {
  selectTarget: "Article Header",
  pageType: "article",
  pagePatterns: ["/articles/[id]"]
}, {
  selectTarget: "Article Summary",
  pageType: "article",
  pagePatterns: ["/articles/[id]"]
}, {
  selectTarget: "Article Content",
  pageType: "article",
  pagePatterns: ["/articles/[id]"]
}];

// ── Articles Create ──
export const articlesCreateSections = [{
  selectTarget: "Toolbar",
  pageType: "article",
  pagePatterns: ["/articles/create"]
}, {
  selectTarget: "Header Card",
  pageType: "article",
  pagePatterns: ["/articles/create"]
}, {
  selectTarget: "Main Content",
  pageType: "article",
  pagePatterns: ["/articles/create"]
}, {
  selectTarget: "Image Upload Bar",
  pageType: "article",
  pagePatterns: ["/articles/create"]
}];

// ── Admin ──
export const adminSections = [{
  selectTarget: "Admin Navigation",
  pageType: "admin",
  pagePatterns: ["/Admin"]
}, {
  selectTarget: "Admin Toggles",
  pageType: "admin",
  pagePatterns: ["/Admin"]
}, {
  selectTarget: "Pending Approvals",
  pageType: "admin",
  pagePatterns: ["/Admin"]
}, {
  selectTarget: "Pending Items Table",
  pageType: "admin",
  pagePatterns: ["/Admin"]
}, {
  selectTarget: "Submission Review Panel",
  pageType: "admin",
  pagePatterns: ["/Admin"]
}, {
  selectTarget: "Task Manager",
  pageType: "admin",
  pagePatterns: ["/Admin"]
}, {
  selectTarget: "Organization Inquiries",
  pageType: "admin",
  pagePatterns: ["/Admin"]
}, {
  selectTarget: "Newsletter Signups",
  pageType: "admin",
  pagePatterns: ["/Admin"]
}, {
  selectTarget: "Data Table",
  pageType: "admin",
  pagePatterns: ["/Admin"]
}];

// ── Help / Contact page ──
export const helpSections = [{
  selectTarget: "Help Hero",
  pageType: "help",
  pagePatterns: ["/help"]
}, {
  selectTarget: "Help Request Form",
  pageType: "help",
  pagePatterns: ["/help"]
}];
export const professionalsIndexSections = [{
  selectTarget: "Professionals Directory Header",
  pageType: "professional",
  pagePatterns: ["/professionals"]
}, {
  selectTarget: "Professional Filters",
  pageType: "professional",
  pagePatterns: ["/professionals"]
}, {
  selectTarget: "Most Relevant Professionals",
  pageType: "professional",
  pagePatterns: ["/professionals"]
}, {
  selectTarget: "Professionals List",
  pageType: "professional",
  pagePatterns: ["/professionals"]
}];
export const professionalsDetailSections = [{
  selectTarget: "Professional Profile Card",
  pageType: "professional",
  pagePatterns: ["/professionals/[id]"]
}, {
  selectTarget: "Professional Expertise Tags",
  pageType: "professional",
  pagePatterns: ["/professionals/[id]"]
}, {
  selectTarget: "Professional Contact",
  pageType: "professional",
  pagePatterns: ["/professionals/[id]"]
}, {
  selectTarget: "Professional Details",
  pageType: "professional",
  pagePatterns: ["/professionals/[id]"]
}];

// ── All sections combined ──
export const allSections = [...sharedSections, ...helpSections, ...homeIndexSections, ...orgIndexSections, ...orgDetailSections, ...orgCreateSections, ...eventsIndexSections, ...eventsDetailSections, ...eventsCreateSections, ...regulationsIndexSections, ...regulationsDetailSections, ...regulationsCreateSections, ...articlesIndexSections, ...articlesDetailSections, ...articlesCreateSections, ...professionalsIndexSections, ...professionalsDetailSections, ...adminSections];

/** Set of all known data-select-target values for quick lookup during capture. */
export const knownSectionLabels = new Set(allSections.map(s => s.selectTarget));

/** Human-friendly page labels for the task selector. */
export const pageLabels = {
  "*": "All Pages",
  "/": "Homepage",
  "/organizations": "Organization Index",
  "/organizations/[id]": "Organization Detail",
  "/organizations/create": "Organization Create",
  "/events": "Events Index",
  "/events/[id]": "Event Detail",
  "/events/create": "Event Create",
  "/regulations": "Regulations Index",
  "/regulations/[id]": "Regulation Detail",
  "/regulations/create": "Regulation Create",
  "/articles": "Articles Index",
  "/articles/[id]": "Article Detail",
  "/articles/create": "Article Create",
  "/professionals": "Professionals Index",
  "/professionals/[id]": "Professional Detail",
  "/professionals/create": "Professional Create",
  "/help": "Help / Contact",
  "/Admin": "Admin"
};